import { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';

import { getAuthState } from './auth';
import { routeTree } from './routeTree.gen';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
    },
  },
});

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  context: {
    queryClient,
    auth: getAuthState(),
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
